import { render, staticRenderFns } from "./MdmBreadcrumb.vue?vue&type=template&id=752b24a5&scoped=true&name=mdm-breadcrumb&"
import script from "./MdmBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./MdmBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./MdmBreadcrumb.vue?vue&type=style&index=0&id=752b24a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b24a5",
  null
  
)

export default component.exports